import React from "react";

import {
  ActionIcon,
  Button,
  Card,
  Checkbox,
  Divider,
  Flex,
  Menu,
  Modal,
  Paper,
  ScrollArea,
  Select,
  SimpleGrid,
  Switch,
  Table,
  Text,
  TextInput,
  Textarea,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useEffect, useRef, useState } from "react";
import useStyles from "./style";
// import { addSubTask } from "../../services/task";
import { IconArrowDown, IconArrowUp, IconPlus, IconTrash } from "@tabler/icons-react";
import { IoIosClose, IoMdCloseCircle } from "react-icons/io";
import { useSelector } from "react-redux";
import {
  addTaskType,
  getFields,
  getSubTask,
  getTaskTypes,
  updateTaskType,
} from "../../services/task";
import { showError } from "../../utils";
import swal from "sweetalert";

// OD-888: System fields available for the report header
const SYSTEM_FIELDS = [
  { key: "dob", label: "Date of Birth" },
  { key: "admissionDate", label: "Admission Date" },
  { key: "facilityName", label: "Facility Name" },
];

const VALUE_TYPES = [
  { value: "text", label: "Plain text" },
  { value: "date", label: "Date" },
  { value: "number", label: "Number" },
  { value: "yesno", label: "Yes / No" },
  { value: "dropdown", label: "Dropdown" },
];

const AddTaskTypeModal = ({ opened, close, edit, data }) => {
  const { classes } = useStyles();
  const ref = useRef();
  const { modalLoading, subTask, fields, taskTypes } = useSelector(
    (state) => state.task,
  );

  const [allSubTask, setAllSubTask] = useState([]);
  const [allTaskFields, setAllTaskFields] = useState([]);

  const [SubTask, setSubTask] = useState("");
  const [taskField, setTaskField] = useState([]);
  const [singleTaskField, setSingleTaskField] = useState("");

  const [list, setList] = useState([]);
  const [checked, setChecked] = useState([]);

  const [showCustomList, setShowCustomList] = useState(false);

  const [editObjIndex, setEditObjIndex] = useState(-1);

  // OD-888: Header builder state
  const [selectedSystemFields, setSelectedSystemFields] = useState([]);
  const [customFields, setCustomFields] = useState([]);
  const [includeAdlMatrix, setIncludeAdlMatrix] = useState(false);
  const [showDescription, setShowDescription] = useState(true);

  useEffect(() => {
    if (subTask?.length > 0) {
      setAllSubTask(
        subTask?.map((data) => {
          return {
            value: JSON.stringify({ name: data?.name, _id: data?._id }),
            label: data?.name,
          };
        }),
      );
    }
  }, [subTask]);

  useEffect(() => {
    if (fields?.length > 0) {
      setAllTaskFields(
        fields?.map((data) => {
          return {
            value: JSON.stringify({
              ...data,
              required: data?.required || false,
            }),
            label: data?.name,
          };
        }),
      );
    }
  }, [fields]);

  useEffect(() => {
    if (opened && edit && data) {
      form.setFieldValue("name", data?.name);
      form.setFieldValue("description", data?.description);
      form.setFieldValue("commentRequired", data?.commentRequired);

      // OD-888: Restore header builder state
      if (data?.headerFields?.length > 0) {
        const sys = data.headerFields.filter((f) => f.type === "system").map((f) => f.key);
        setSelectedSystemFields(sys.length > 0 ? sys : []);
        setCustomFields(data.headerFields.filter((f) => f.type === "custom"));
      }
      setIncludeAdlMatrix(data?.includeAdlMatrix || false);
      setShowDescription(data?.showDescription !== false);
      const _list = data?.subTasks?.map((v) => {
        return {
          subTask: JSON.stringify(v?.task),
          taskField: v?.fields?.map((x) => JSON.stringify(x)),
        };
      });
      setList(_list);

      setAllSubTask(
        subTask?.map((data) => {
          return {
            value: JSON.stringify(data),
            label: data?.name,
          };
        }),
      );
      setAllTaskFields(
        fields?.map((data) => {
          return {
            value: JSON.stringify({
              ...data,
              required: data?.required || false,
            }),
            label: data?.name,
          };
        }),
      );
    }
    getTaskTypes("all", false);
  }, [opened]);

  const resetForm = () => {
    form?.reset();
    close();
    setTaskField([]);
    // OD-888: Reset header builder
    setSelectedSystemFields(["residentName"]);
    setCustomFields([]);
    setIncludeAdlMatrix(false);
  };

  const Submit = async (values) => {
    if (list?.length > 0) {
      const newList = list?.map((v) => {
        const task = JSON.parse(v?.subTask);
        return {
          task: {
            name: task?.name,
            _id: task?._id,
          },
          fields: v?.taskField?.map((x) => {
            const field = JSON.parse(x);
            return {
              name: field?.name,
              _id: field?._id,
              ...(field?.required !== undefined && {
                required: field.required,
              }),
            };
          }),
        };
      });
      // OD-888: Build headerFields array from system + custom selections
      const headerFields = [
        ...selectedSystemFields.map((key, i) => {
          const sf = SYSTEM_FIELDS.find((f) => f.key === key);
          return { type: "system", key, label: sf?.label || key, valueType: "text", order: i };
        }),
        ...customFields.map((cf, i) => ({
          type: "custom",
          key: cf.key || cf.label?.toLowerCase().replace(/\s+/g, "_") || `custom_${i}`,
          label: cf.label || "",
          valueType: cf.valueType || "text",
          choices: cf.valueType === "dropdown" ? cf.choices || [] : [],
          order: selectedSystemFields.length + i,
        })),
      ];

      const finalObj = {
        name: values?.name,
        description: values?.description ? values?.description : "",
        subTasks: newList,
        commentRequired: values?.commentRequired,
        headerFields,
        includeAdlMatrix,
        showDescription,
      };
      
      if (edit) {
        let obj = {
          id: data?.id,
          ...finalObj,
        };
        await updateTaskType(obj, resetForm);
      } else {
        console.log("🚀 ~ Submit ~ finalObj:", finalObj)
        await addTaskType(finalObj, resetForm);
      }
    } else {
      showError("Please Add Task List First", 400);
    }
    // if (SaveValues.length > 0) {
    //   if (edit) {
    //     let obj = {
    //       id: data?.id,
    //       name: form.getInputProps("name").value,
    //       description: form.getInputProps("description").value,
    //       subTasks: taskList?.map((v) => ({
    //         task: v?.SubTask?._id,
    //         fields: v?.taskField?.map((vv) => vv?._id),
    //       })),
    //     };

    //     await updateTaskType(obj, resetForm);
    //   } else {
    //     await addTaskType(
    //       {
    //         name: values?.name,
    //         description: values?.description,
    //         subTasks: SaveValues,
    //       },
    //       resetForm
    //     );
    //   }
    // } else {
    //   showError("Please Add Task List First", 400);
    // }
  };

  const form = useForm({
    initialValues: {
      name: "",
      description: "",
      general: false,
      commentRequired: false,
    },
    validate: {
      name: (value) => (value ? null : "Required"),
    },
  });

  useEffect(() => {
    if (opened) {
      getSubTask();
      getFields();
    }
  }, [opened]);

  const resetListItem = () => {
    setSubTask("");
    setTaskField([]);
    setSingleTaskField("");
    !showCustomList && setShowCustomList(false);
  };

  const deleteList = (index) => {
    const temp = [...list];
    temp.splice(index, 1);
    setList(temp);
  };

  const setExistingList = (subTask, taskField, id) => {
    if (checked?.includes(id)) {
      setList((pre) => pre?.filter((v) => v?._id !== id));
      setChecked((pre) => [...pre]?.filter((v) => v !== id));
    } else {
      setChecked((pre) => [...pre, id]);
      setList((pre) => [
        ...pre,
        {
          subTask: subTask,
          taskField: taskField,
          _id: id,
        },
      ]);
    }
  };

  const handleEditList = (index) => {
    setEditObjIndex(index);
    setShowCustomList(true);
    const obj = JSON.parse(list[index]?.subTask);
    setAllSubTask((pre) => [
      ...pre,
      {
        value: JSON.stringify({ name: obj?.name, _id: obj?._id }),
        label: obj?.name,
      },
    ]);
    setSubTask(JSON.stringify({ name: obj?.name, _id: obj?._id }));
    setTaskField(list[index]?.taskField);
  };

  const addToList = () => {
    if (SubTask?.trim() != "" && (singleTaskField || taskField?.length > 0)) {
      const _taskFields =
        singleTaskField !== "" ? [...taskField, singleTaskField] : taskField;
      if (editObjIndex !== -1) {
        const tempList = [...list];
        tempList[editObjIndex] = {
          subTask: SubTask,
          taskField: _taskFields,
        };
        setList(tempList);
        setEditObjIndex(-1);
        resetListItem();
        setShowCustomList(false);
      } else {
        setList((pre) => [
          ...pre,
          {
            subTask: SubTask,
            taskField: _taskFields,
          },
        ]);
        resetListItem();
      }
    }
  };

  return (
    <Modal
      className={classes.mymodal}
      opened={opened}
      size={"xl"}
      onClose={() => {
        close();
        form?.reset();
        setList([]);
        resetListItem();
      }}
      radius={15}
      shadow="md"
      overlayProps={{ blur: 3 }}
      title={
        <Text sx={{ fontFamily: "Inter", fontSize: 22, fontWeight: 600 }}>
          {edit ? "Edit Task Type" : "Add Task Type"}
        </Text>
      }
      centered
      zIndex={1000}
    >
      <form ref={ref} onSubmit={form?.onSubmit((values) => Submit(values))}>
        <div
          style={{
            padding: "1rem",
            border: "1px solid #CBCBCB66",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            borderRadius: "0.25rem",
            borderBottom: "none !important",
          }}
        >
          <TextInput
            label={"Name"}
            size="md"
            className={classes.myfont}
            placeholder="Name"
            {...form.getInputProps("name")}
          />
          <Textarea
            label={"Description"}
            size="md"
            className={classes.myfont}
            placeholder="Description"
            {...form.getInputProps("description")}
          />
          <Flex align="center" gap="sm" mt={4}>
            <Switch
              checked={showDescription}
              onChange={(e) => setShowDescription(e.currentTarget.checked)}
              color="yellow"
              size="xs"
            />
            <Text size="xs" color="dimmed">
              Show description when completing this task
            </Text>
          </Flex>

          {/* OD-888: Report Header Fields Builder */}
          <Divider
            label={<Text fw={600} size="sm">Report Header Fields</Text>}
            labelPosition="left"
            my={4}
          />
          <Text size="xs" color="dimmed" mb={4}>
            Choose which fields appear at the top of this task's daily report and completion form.
          </Text>

          {/* System fields checkboxes */}
          <Paper p="sm" withBorder radius="sm" mb="sm">
            <Text size="sm" fw={500} mb={8}>System Fields</Text>
            <SimpleGrid cols={2} spacing="xs">
              {SYSTEM_FIELDS.map((sf) => (
                <Checkbox
                  key={sf.key}
                  label={sf.label}
                  color="yellow"
                  disabled={sf.locked}
                  checked={selectedSystemFields.includes(sf.key)}
                  onChange={(e) => {
                    if (sf.locked) return;
                    setSelectedSystemFields((prev) =>
                      e.currentTarget.checked
                        ? [...prev, sf.key]
                        : prev.filter((k) => k !== sf.key)
                    );
                  }}
                />
              ))}
            </SimpleGrid>
          </Paper>

          {/* Custom fields builder */}
          <Paper p="sm" withBorder radius="sm" mb="sm">
            <Text size="sm" fw={500} mb={8}>Custom Fields</Text>
            {customFields.map((cf, i) => (
              <Flex key={`cf-${i}`} align="flex-end" gap="xs" mb="xs">
                <Flex direction="column" gap={2} mt={i === 0 ? 24 : 0}>
                  <ActionIcon
                    size="xs"
                    variant="subtle"
                    disabled={i === 0}
                    onClick={() => {
                      const reordered = [...customFields];
                      [reordered[i - 1], reordered[i]] = [reordered[i], reordered[i - 1]];
                      setCustomFields(reordered);
                    }}
                  >
                    <IconArrowUp size={12} />
                  </ActionIcon>
                  <ActionIcon
                    size="xs"
                    variant="subtle"
                    disabled={i === customFields.length - 1}
                    onClick={() => {
                      const reordered = [...customFields];
                      [reordered[i], reordered[i + 1]] = [reordered[i + 1], reordered[i]];
                      setCustomFields(reordered);
                    }}
                  >
                    <IconArrowDown size={12} />
                  </ActionIcon>
                </Flex>
                <TextInput
                  label={i === 0 ? "Label" : ""}
                  placeholder="e.g. Physician"
                  size="xs"
                  value={cf.label}
                  onChange={(e) => {
                    const updated = [...customFields];
                    updated[i] = { ...updated[i], label: e.currentTarget.value };
                    setCustomFields(updated);
                  }}
                  style={{ flex: 1 }}
                />
                <Select
                  label={i === 0 ? "Value type" : ""}
                  data={VALUE_TYPES}
                  size="xs"
                  value={cf.valueType || "text"}
                  onChange={(val) => {
                    const updated = [...customFields];
                    updated[i] = { ...updated[i], valueType: val };
                    setCustomFields(updated);
                  }}
                  style={{ width: 130 }}
                />
                {cf.valueType === "dropdown" && (
                  <TextInput
                    label={i === 0 ? "Choices" : ""}
                    placeholder="Option1, Option2"
                    size="xs"
                    value={(cf.choices || []).join(", ")}
                    onChange={(e) => {
                      const updated = [...customFields];
                      updated[i] = {
                        ...updated[i],
                        choices: e.currentTarget.value.split(",").map((s) => s.trim()),
                      };
                      setCustomFields(updated);
                    }}
                    style={{ flex: 1 }}
                  />
                )}
                <ActionIcon
                  color="red"
                  variant="subtle"
                  onClick={() => {
                    setCustomFields((prev) => prev.filter((_, idx) => idx !== i));
                  }}
                  mt={i === 0 ? 24 : 0}
                >
                  <IconTrash size={16} />
                </ActionIcon>
              </Flex>
            ))}
            <Button
              variant="subtle"
              color="yellow"
              size="xs"
              leftIcon={<IconPlus size={14} />}
              onClick={() =>
                setCustomFields((prev) => [
                  ...prev,
                  { label: "", valueType: "text", choices: [] },
                ])
              }
            >
              Add custom field
            </Button>
          </Paper>

          {/* Header preview */}
          {(selectedSystemFields.length > 0 || customFields.length > 0) && (
            <Paper p="sm" withBorder radius="sm" mb="sm" bg="#FAFAF8">
              <Text size="xs" fw={600} mb={6} color="dimmed">HEADER PREVIEW</Text>
              <Table fontSize="xs" verticalSpacing={4}>
                <tbody>
                  {selectedSystemFields.map((key) => {
                    const sf = SYSTEM_FIELDS.find((f) => f.key === key);
                    return (
                      <tr key={key}>
                        <td style={{ fontWeight: 600, width: "40%" }}>{sf?.label}</td>
                        <td style={{ color: "#999" }}>— populated from client record —</td>
                      </tr>
                    );
                  })}
                  {customFields
                    .filter((cf) => cf.label)
                    .map((cf, i) => (
                      <tr key={`cp-${i}`}>
                        <td style={{ fontWeight: 600, width: "40%" }}>{cf.label}</td>
                        <td style={{ color: "#999" }}>
                          {cf.valueType === "dropdown"
                            ? (cf.choices || []).join(" / ") || "— dropdown —"
                            : `— ${cf.valueType || "text"} —`}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </Paper>
          )}

          {/* OD-888: ADL Matrix Toggle */}
          <Divider
            label={<Text fw={600} size="sm">ADL Matrix</Text>}
            labelPosition="left"
            my={4}
          />
          <Switch
            label="Include ADL Matrix"
            description="When enabled, this task will display the client's ADL Matrix from their Care Plan at the time of completion."
            color="yellow"
            checked={includeAdlMatrix}
            onChange={(e) => setIncludeAdlMatrix(e.currentTarget.checked)}
            mb="sm"
          />
          {includeAdlMatrix && (
            <Paper p="xs" withBorder radius="sm" mb="sm" bg="#FEF9C3">
              <Text size="xs" color="dimmed">
                The matrix will be pulled live from the selected client's Care Plan when staff
                complete this task. Configure the ADL Matrix in each client's Care Plan tab.
              </Text>
            </Paper>
          )}

          <Flex align="center" justify="space-between">
            <div className={classes.buttonBox}>
              <ExistingListMenu
                data={taskTypes}
                setExistingList={setExistingList}
                checked={checked}
                setChecked={setChecked}
              />
              {/* <MultiSelect
              checkIconPosition="right"
              data={taskTypes?.map(()=>{
                return {
                  value:
                }
              })}
              dropdownOpened
              pb={150}
              label="Control check icon"
              placeholder="Pick value"
              defaultValue={["React"]}
            /> */}
              <Button
                variant="filled"
                color="yellow"
                leftIcon={<IconPlus />}
                onClick={() => setShowCustomList(!showCustomList)}
              >
                Custom List
              </Button>
            </div>
            <Switch
              label="Comment Required"
              color="yellow"
              {...form.getInputProps("commentRequired", { type: "checkbox" })}
            />
          </Flex>
        </div>

        <Card
          sx={{
            paddingTop: 20,
            borderTopWidth: 1,
            borderTopColor: "#CBCBCB66",
            borderTopStyle: "solid",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            // backgroundColor: "#8492a7",
          }}
          shadow={"xs"}
        >
          <div className={classes.toDoHeadingBox}>
            <h2>TO DO LISTS</h2>
          </div>
          <ScrollArea w={715} type="always">
            <div className={classes.listCardBox}>
              {list?.map((v, i) => (
                <ListCard
                  key={i}
                  index={i}
                  data={v}
                  deleteList={deleteList}
                  handleEditList={handleEditList}
                  setChecked={setChecked}
                />
              ))}
            </div>
          </ScrollArea>
        </Card>

        {showCustomList && (
          // <Card
          //   sx={{
          //     paddingTop: 20,
          //     borderTopWidth: 1,
          //     borderTopColor: "#CBCBCB66",
          //     borderTopStyle: "solid",
          //     display: "flex",
          //     flexDirection: "column",
          //     gap: "20px",
          //   }}
          //   shadow={"xs"}
          // >
          <div
            style={{
              padding: "1rem",
              border: "1px solid #CBCBCB66",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              borderRadius: "0.25rem",
              borderTop: "none",
              borderBottom: "none",
            }}
          >
            <div className={classes.customListBox}>
              <Select
                className={classes.selectBox}
                label=""
                data={allSubTask}
                value={SubTask}
                placeholder="Untitled List"
                nothingFound="Nothing found"
                searchable
                creatable
                getCreateLabel={(query) => `+ Create ${query}`}
                onCreate={(query) => {
                  const item = {
                    value: JSON.stringify({ name: query, _id: null }),
                    label: query,
                  };
                  setAllSubTask((current) => [...current, item]);
                  return item;
                }}
                onChange={(e) => {
                  setSubTask(e);
                }}
              />

              {taskField?.map((v, i) => {
                return (
                  <div className={classes.customListRow} key={i}>
                    <Checkbox checked={false} disabled />
                    <Select
                      className={classes.selectBox}
                      label=""
                      value={v}
                      data={[
                        {
                          label: JSON.parse(v)?.name,
                          value: v,
                        },
                      ]}
                      placeholder="Add Action"
                      nothingFound="Nothing found"
                      searchable
                      creatable
                      getCreateLabel={(query) => `+ Create ${query}`}
                      disabled
                    />
                    <Flex pl={75} gap={30} align="center">
                      <Checkbox
                        color="yellow"
                        label="Required"
                        checked={JSON.parse(v)?.required ?? false}
                        onChange={() => {
                          const updated = taskField.map((item, index) => {
                            if (index !== i) return item;
                            const parsed = JSON.parse(item);
                            return JSON.stringify({
                              ...parsed,
                              required: !parsed.required,
                            });
                          });
                          setTaskField(updated);
                        }}
                      />
                      <Button
                        style={{
                          paddingRight: 0,
                          backgroundColor: "transparent",
                        }}
                        variant="light"
                        color="yellow"
                        onClick={() => {
                          const temp = [...taskField];
                          temp.splice(i, 1);
                          setTaskField(temp);
                        }}
                        leftIcon={<IoIosClose size={30} />}
                      />
                    </Flex>
                  </div>
                );
              })}

              <div className={classes.customListRow}>
                <Checkbox checked={false} disabled />
                <Select
                  className={classes.selectBox}
                  label=""
                  value={singleTaskField}
                  data={allTaskFields}
                  placeholder="Add Action"
                  nothingFound="Nothing found"
                  searchable
                  creatable
                  getCreateLabel={(query) => `+ Create ${query}`}
                  onCreate={(query) => {
                    const item = {
                      value: JSON.stringify({
                        name: query,
                        _id: null,
                        required: false,
                      }),
                      label: query,
                    };
                    setSingleTaskField("");
                    return item;
                  }}
                  onChange={(e) => {
                    setSingleTaskField(e);
                  }}
                  //                   onChange={(e) => {
                  //   const parsedItem = JSON.parse(e)
                  //   const obj = {
                  //     ...parsedItem,
                  //     required: false
                  //   }
                  //   console.log("🚀 ~ AddTaskTypeModal ~ obj:", obj, e)
                  //   setSingleTaskField(JSON.stringify(obj));
                  // }}
                />
                <Button
                  style={{ paddingRight: 0, marginLeft: "200px" }}
                  variant="filled"
                  color="yellow"
                  onClick={() => {
                    if (SubTask !== "" && singleTaskField !== "") {
                      setTaskField((pre) => [...pre, singleTaskField]);
                      setSingleTaskField("");
                    } else {
                      swal({
                        title: `Task item required`,
                        text: "Please select or click create to add item to the list.",
                        dangerMode: true,
                      });
                    }
                  }}
                  leftIcon={<IconPlus />}
                />
              </div>
            </div>

            <div>
              <Button color="yellow" onClick={addToList} variant="filled">
                {editObjIndex !== -1 ? "Update Task" : "Add Task"}
              </Button>
            </div>
          </div>
          //  </Card>
        )}

        <Card
          sx={{
            paddingTop: 20,
            borderTopWidth: 1,
            borderTopColor: "#CBCBCB66",
            borderTopStyle: "solid",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            // zIndex: -1,
          }}
          shadow={"xs"}
        >
          <Button
            color="yellow"
            loading={modalLoading}
            type="submit"
            variant="filled"
          >
            Save
          </Button>
        </Card>
      </form>
    </Modal>
  );
};

const ExistingListMenu = ({ data, setExistingList, checked }) => {
  const { classes } = useStyles();
  return (
    <Menu shadow="md" width={250}>
      <Menu.Target>
        <Button
          className={classes.existingListButton}
          variant="filled"
          color="yellow"
          leftIcon={<IconPlus />}
        >
          Existing List
        </Button>
      </Menu.Target>

      <Menu.Dropdown style={{ overflow: "auto", height: "200px" }}>
        {data?.map((v, i) =>
          v?.subTasks?.map((x, index) => {
            return (
              <Menu.Item
                key={index}
                onClick={() => {
                  setExistingList(
                    JSON.stringify(x?.task),
                    x?.fields?.map((v) => JSON.stringify(v)),
                    x?.task?._id,
                  );
                }}
              >
                <div className={classes.dropdownItem}>
                  <p style={{ margin: 0 }}>
                    {x?.task?.name} ({x?.fields?.length})
                  </p>
                  <Checkbox
                    key={i}
                    disabled
                    checked={checked?.includes(x?.task?._id)}
                  />
                </div>
              </Menu.Item>
            );
          }),
        )}
      </Menu.Dropdown>
    </Menu>
  );
};

const ListCard = ({ data, index, deleteList, handleEditList, setChecked }) => {
  const { classes } = useStyles();
  return (
    <div className={classes.listCard} onClick={() => handleEditList(index)}>
      <div className={classes.closeBtn}>
        <IoMdCloseCircle
          color="orange"
          size={22}
          style={{ cursor: "pointer" }}
          onClick={(e) => {
            e.stopPropagation();
            deleteList(index);
            setChecked((pre) => pre?.filter((x) => x !== data?._id));
          }}
        />
      </div>
      {/* <p className={classes.index}>
        <span
          style={{ cursor: "pointer" }}
          onClick={() => handleEditList(index)}
        >
          {index + 1}
        </span>
      </p> */}
      <h3 className={classes.title}>{JSON.parse(data?.subTask)?.name}</h3>
      <div className={classes.tilteAndCheckbox}>
        {data?.taskField?.map((v, i) => {
          return (
            <Checkbox
              key={i}
              checked={false}
              disabled
              label={
                <Flex>
                  {JSON.parse(v)?.name}
                  {JSON.parse(v)?.required ? <Text color="red"> *</Text> : ""}
                </Flex>
              }
            />
          );
        })}
      </div>
    </div>
  );
};

export default AddTaskTypeModal;
